export default {
  OvernightIndicator__TEXT: "Overnight",
  OvernightIndicator__TEXT_ARIA: "This flight has overnight connection.",
};
